<template>
  <div>
    <el-table :data="projectList">
      <el-table-column prop="id" label="ID"> </el-table-column>
      <el-table-column prop="__problem" label="问题"> </el-table-column>
      <el-table-column prop="batchStatus" label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">
            {{ scope.row.__status.text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="展示">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="toggleEnabled(scope.row)"
            :value="scope.row.enabled"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始时间">
        <template slot-scope="scope">
          <span>{{ scope.row.startTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间">
        <template slot-scope="scope">
          <span>{{ scope.row.endTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-tooltip content="查看">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-view"
              @click="viewDetail(scope.row)"
            ></el-button>
          </el-tooltip>
          <!-- <el-tooltip content="投资记录">
          <router-link :to="`/home/votingStrategy/records/${scope.row.id}`" class="link-button">
            <el-button type="success" size="small" circle icon="el-icon-tickets"></el-button>
          </router-link>
        </el-tooltip> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
    <detail @refresh="handleCurrentChange({ page: 1 })"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';

export default {
  name: 'votingStrategyList',
  computed: {
    ...mapState('votingStrategy', ['totalCount', 'pagination']),
    ...mapGetters('votingStrategy', ['projectList'])
  },
  components: {
    Pagination,
    Detail
  },
  methods: {
    ...mapMutations('votingStrategy', ['setEditingProject']),
    ...mapActions('votingStrategy', ['updateEnabled']),
    viewDetail(project) {
      this.setEditingProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    toggleEnabled(row) {
      this.updateEnabled({
        ballotId: row.id,
        enabled: !row.enabled
      }).then(res => {
        this.$emit('refresh');
      });
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
